<template>
  <div class="py-3">
    <div class="bg-white">
      <div class="pt-3 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-info-circle mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Seguimiento de Solicitud
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-3 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Fecha de Solicitud:
              </p>
              <p class="font-16">
                {{ trackedRequest?.requestDate | date }}
              </p>
            </div>
            <div class="col-3 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Sometido por:
              </p>
              <p class="font-16">
                {{ trackedRequest?.submittedBy }}
              </p>
            </div>
            <div class="col-6 col-lg-6 mb-3">
              <p class="font-14 text-muted mb-1">
                Razón:
              </p>
              <p class="font-16">
                {{ trackedRequest?.reason }}
              </p>
            </div>
            <div class="col-12 mb-3">
              <p class="font-14 text-muted mb-1">
                Comentario:
              </p>
              <p class="font-16">
                {{ trackedRequest?.comment }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-2 pl-3">
        <div class="d-flex align-items-center mb-2">
          <i class="fas fa-map-marker-alt mr-2 text-orange"></i>
          <div class="color-gray-7 font-16 font-weight-bold">
            Información de Localidad
          </div>
        </div>
        <div class="m-2 pt-1">
          <div class="row mb-2">
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Centro:
              </p>
              <p class="font-16">
                {{ trackedRequest?.center | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-3 mb-3">
              <p class="font-14 text-muted mb-1">
                Municipio:
              </p>
              <p class="font-16">
                {{ trackedRequest?.municipality | empty }}
              </p>
            </div>
            <div class="col-12 col-lg-6 mb-3">
              <p class="font-14 text-muted mb-1">
                Escuela:
              </p>
              <p class="font-16">
                {{ trackedRequest?.school | empty }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import IconView from 'icon-view';
import inventoryOrderBooksService from '@/services/api/inventoryOrderBooks.api';

export default {
  name: 'TrackedInfo',
  components: {
    SectionTitle,
    IconView,
  },

  props: {
    requestId: {
      type: Number,
    },
  },
  data() {
    return {
      trackedRequest: null,
    };
  },
  mounted() {
    this.getRequestProgress();
  },
  methods: {
    async getRequestProgress() {
      const { data } = await inventoryOrderBooksService.trackRequestProgress(
        this.requestId
      );
      this.trackedRequest = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
</style>
